import React from 'react'
import { Switch, Route, Redirect } from "react-router-dom"
import LoginPage from './routing/LoginPage/LoginPage'
import MainPage from './routing/MainPage/MainPage'
import ProtectedRoute from './routing/ProtectedRoute'
import {checkJWTToken} from './services/googleLoginService'

function App() {
    function localise() {
        setTimeout(function () {
            if (!window.Apex)
                return;
            window.Apex.chart = {
                locales: [
                    {
                        name: "ru",
                        options: {
                            months: [
                                "Январь",
                                "Февраль",
                                "Март",
                                "Апрель",
                                "Май",
                                "Июнь",
                                "Июль",
                                "Август",
                                "Сентябрь",
                                "Октябрь",
                                "Ноябрь",
                                "Декабрь"
                            ],
                            shortMonths: [
                                "Янв",
                                "Фев",
                                "Мар",
                                "Апр",
                                "Май",
                                "Июн",
                                "Июл",
                                "Авг",
                                "Сен",
                                "Окт",
                                "Ноя",
                                "Дек"
                            ],
                            days: [
                                "Воскресенье",
                                "Понедельник",
                                "Вторник",
                                "Среда",
                                "Четверг",
                                "Пятница",
                                "Суббота"
                            ],
                            shortDays: ["Вск", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
                            toolbar: {
                                exportToSVG: "Сохранить в SVG",
                                exportToPNG: "Сохранить в PNG",
                                menu: "Меню",
                                selection: "Выбрать",
                                selectionZoom: "Масштабирование",
                                zoomIn: "Увеличить",
                                zoomOut: "Уменьшить",
                                pan: "Навигация",
                                reset: "Сбросить масштабирование"
                            }
                        }
                    }
                ],
                defaultLocale: "ru"
            };
        }, 50);
    }

    localise();

    const token = localStorage.getItem('JWTToken');
    if (token) {
        checkJWTToken(token);
    }
    const [loggedIn, setLoggedIn] = React.useState(!!token);

    const handleLogin = () => {
        setLoggedIn(true)
    }

    return (
        <Switch>
            <Route path="/login" exact >
                {loggedIn ? <Redirect to="/portfolio" /> : <LoginPage handleLogin={handleLogin}/>}
            </Route>
            <ProtectedRoute path="/portfolio" loggedIn={loggedIn} component={MainPage} />
            <Route>
                {!loggedIn ?  <Redirect to="/login" /> : <Redirect to="/portfolio" />}
            </Route>
        </Switch>
    );
}

export default App
